<div class="tracking-page">
  <common-customer-order-tracking
    class="full-screen"
    [loadingState]="loadingState"
    [facebookClientToken]="environment.facebookAccessToken"
    [errorState]="errorState"
    [orderDetails]="orderTrackingInfo"
    [brandingInfo]="brandingAndDetails && brandingAndDetails.brandingInfo"
    [merchantDetails]="brandingAndDetails && brandingAndDetails.merchantDetails"
    (promotionFabDisplayChange)="onPromotionFabDisplayChange($event)"
    [isDevEnvironment]="isDevEnvironment">
  </common-customer-order-tracking>
</div>
